import { styled, StyledEngineProvider } from '@mui/material'
import Container from '@mui/material/Container'
import { PropsWithChildren } from 'react'
import ScrollTop from '../../../components/ScrollTop'
import TermsAndConditionsLogin from '../../buckets/components/modals/TermsAndConditionsLogin'
import Appbar from '../../conversion/components/AppBar'
import Footer from '../../conversion/components/Footer'

const Wrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.customGrey[100],
  overflowY: 'auto',
  color: '#2b2b2b', // TODO: deprecate color hex and use theme
  textAlign: 'center'
}))

/**
 * Renders Layout
 * @param props Component properties with child components
 */

export default function Layout(props: PropsWithChildren<{}>) {
  return (
    <>
      <StyledEngineProvider injectFirst>
        <ScrollTop />
        <Appbar />
        <Wrapper>
          <Container sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: 0 }}>{props.children}</Container>
          <Footer />
        </Wrapper>
      </StyledEngineProvider>
      <TermsAndConditionsLogin />
    </>
  )
}
